import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { Engagement } from '../../../../interfaces';
import { AppService, BaseEngagementService, DomainDataService } from '../../../../services';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'common-engagement-grid',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './engagement-grid.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./engagement-grid.part.scss'],
})
export class CommonEngagementGridPart {

	public pageService = input.required<BaseEngagementService>();
	public data = input.required<Engagement[]>();

	private readonly dialogService = inject(DialogService);
	public readonly appService = inject(AppService);
	private readonly util = inject(UtilityService);
	private readonly domainDataService = inject(DomainDataService);

	public setup = computed(() => {
		const service = this.pageService();
		return getSetup(
			service,
			this.util,
			this.dialogService,
			this.appService,
			service.page(),
			this.domainDataService
		);
	});

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		const service = this.pageService();
		const layout = service.layout();
		if (layout) {
			return { layout: layout, viewSelector: true };
		}
		return undefined;
	});


}
